if (!customElements.get('kit-this')) {
  class KitThis extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-kit-this-select]');
      this.comments = this.querySelector('[data-kit-this-comments]');
      this.textarea = this.querySelector('[data-kit-this-textarea]');
      this.tooltipToggle = this.querySelector('[data-kit-this-tooltip-toggle]');

      if (this.select) {
        this.select.addEventListener('change', this.onSelectChange.bind(this));
        this.onSelectChange();
      }

      if (this.tooltipToggle) {
        this.tooltipToggle.addEventListener('click', this.onTooltipToggle.bind(this));
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeTooltip();
        });
        this.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') this.closeTooltip();
        });
      }
    }

    onSelectChange() {
      const isYes = this.select.value === 'Yes';
      if (this.comments) this.comments.hidden = !isYes;
      if (this.textarea) {
        // Disabled fields are excluded from the add-to-cart submit, so a
        // "No" answer never sends an empty Kitting Instructions property.
        this.textarea.disabled = !isYes;
        if (!isYes) this.textarea.value = '';
      }
    }

    onTooltipToggle() {
      const expanded = this.tooltipToggle.getAttribute('aria-expanded') === 'true';
      this.tooltipToggle.setAttribute('aria-expanded', String(!expanded));
    }

    closeTooltip() {
      if (this.tooltipToggle) this.tooltipToggle.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('kit-this', KitThis);
}
